
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import type { WaterfallMoment } from '@xt/client/entities/course-v2/types.d'

const randomColors = ['#CBC3C6', '#C5CAC7', '#B8B6A2']

@Observer
@Component({
  components: {
    HeaderImage,
    LazyImg
  }
})
export default class MomentCard extends Vue {
  // 不展示置顶标签
  @Prop({ default: false }) hideTop: boolean

  @Prop({ required: true }) item: WaterfallMoment

  // 对于没有图片的内容，展示一个随机色块
  randomBgColor: string = ''

  // 有标题优先取标题，没有标题取正文，超出两行溢出隐藏
  get contentTitle() {
    return this.item.title ? this.item.title : this.item.content
  }

  get hasImageData() {
    return Array.isArray(this.toJS(this.item.pictures)) && this.item.pictures.length > 0
  }

  // 根据限制宽度按比例，计算图片高度
  compactImageSize(originWidth, originHeight) {
    const limitWidth = 194
    const shouldHeigth = Math.floor((limitWidth * originHeight) / originWidth)

    return [limitWidth, shouldHeigth]
  }

  getImageHeight(originWidth, originHeight) {
    return Math.max(100, Math.min(248, this.compactImageSize(originWidth, originHeight)[1]))
  }

  getImageURL(url, originWidth, originHeight) {
    // console.log(originWidth, originHeight, 194, 248, ...this.compactImageSize(originWidth, originHeight))
    const limitWidth = 194
    const limitHeight = 248
    const minHeight = 100
    const [, shouldHeigth] = this.compactImageSize(originWidth, originHeight)

    if (shouldHeigth > limitHeight) {
      return this.ossProcessImg(url, Math.floor(limitWidth * 2), Math.floor(limitHeight * 2), true)
    } else if (100 < shouldHeigth && shouldHeigth <= limitHeight) {
      return this.ossProcessImg(url, Math.floor(limitWidth * 2), Math.floor(shouldHeigth * 2))
      // 兼容过宽图片，缩放至可视窗口的问题
    } else {
      return this.ossProcessImg(url, Math.floor(limitWidth * 2), Math.floor(minHeight * 2), true)
    }
  }

  handleClickLike(item: WaterfallMoment) {
    this.$emit('like', item)
  }

  created() {
    if (!this.hasImageData) {
      this.randomBgColor = randomColors[Math.floor(Math.random() * randomColors.length)]
    }
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
